import { useGlobalAction } from "@gadgetinc/react";
import { useEffect } from "react";
import { api } from "../../api";

export const CheckOnBoardingPrerequisites = ({
  prerequisites,
  setPrerequisites,
  customer,
}) => {
  const [, checkOnBoardingPrerequisites] = useGlobalAction(
    api.onboarding.checkOnBoardingPrerequisites,
  );

  useEffect(() => {
    if (!customer) {
      return;
    }
    const fetch = async () => {
      const { id } = customer;
      if (id) {
        const { data } = await checkOnBoardingPrerequisites();
        setPrerequisites(data);
      }
    };
    fetch();
  }, [customer?.id]);

  const hasMissingPlans =
    prerequisites?.optinsPlanIsMissing ||
    prerequisites?.subscriptionPlanIsMissing;

  if (!hasMissingPlans) {
    return null;
  }

  return (
    <div className="w-full max-w-2xl mb-6 rounded-lg border border-amber-200 bg-amber-50 p-4 shadow-sm">
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0">
          <svg
            className="h-6 w-6 text-amber-600"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="2"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
            />
          </svg>
        </div>
        <div className="flex-1">
          <h3 className="text-sm font-semibold text-amber-900 mb-2">
            Missing Configuration
          </h3>
          <div className="text-sm text-amber-800 space-y-1">
            {prerequisites?.optinsPlanIsMissing && (
              <p>• Optins plan is required to proceed with checkout</p>
            )}
            {prerequisites?.subscriptionPlanIsMissing && (
              <p>• Subscription plan is required to proceed with checkout</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
